import { channel } from '../platform/channel';
// 추억함의 calm 완료 순간 계약을 재사용해요. 배경음은 재생하지 않아요.
export function playJuice(moment:'save.success'|'stamp.collect'|'error.soft') {
 try { if(localStorage.getItem('juice.muted')==='true') return; const audio=new Audio(`/audio/${({'save.success':'save-success','stamp.collect':'stamp-collect','error.soft':'error-soft'} as const)[moment]}.mp3`);audio.volume=.28;void audio.play().catch(()=>undefined);
 if(moment!=='error.soft'){if(import.meta.env.MODE==='toss'){void import('@apps-in-toss/web-framework').then(({Device})=>Device.triggerHaptic({type:'tickWeak'})).catch(()=>undefined);}else navigator.vibrate?.(12);}
 }catch{/* 완료 동작은 소리 권한과 독립이에요. */}
}
